import Icon from '../components/Icon.vue'

Icon.register({
  'golf-ball': {
    width: 416,
    height: 512,
    paths: [
      {
        d: 'M96 416H320C320 433.7 305.7 448 288 448H272C254.3 448 240 462.3 240 480V500C240 506.6 234.6 512 228 512H188C181.4 512 176 506.6 176 500V480C176 462.3 161.7 448 144 448H128C110.3 448 96 433.7 96 416zM416 208C416 282.2 377 347.2 318.5 384H97.5C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0S416 93.1 416 208zM235.9 251.9C254.2 251.9 269 237.1 269 218.8 269 204.4 259.7 192.5 246.9 187.9 256.5 214.7 231.3 239.2 205 229.8 209.6 242.6 221.5 251.9 235.9 251.9zM285 298.8C285 284.4 275.7 272.5 262.9 267.9 272.5 294.7 247.3 319.2 221 309.8 225.6 322.6 237.5 331.9 251.9 331.9 270.2 331.9 285 317 285 298.8zM349 234.8C349 220.4 339.7 208.5 326.9 203.9 336.5 230.7 311.3 255.2 285 245.8 289.6 258.6 301.5 267.9 315.9 267.9 334.2 267.9 349 253 349 234.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/golf-ball.js
// module id = WIGv
// module chunks = 144